import { useEffect, useState } from 'react'

export function useSvgUrl(svg: string | null | undefined): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!svg) return

    let fixedSvg = svg.replace(/xlink:href=/g, "href=")

    const blob = new Blob([fixedSvg], { type: 'image/svg+xml' })
    const url = URL.createObjectURL(blob)
    setUrl(url)

    return () => URL.revokeObjectURL(url)
  }, [svg])

  return url
}
